import postponeRendering from "common/utils/web-vitals";

import "./continue-shopping-modal-title.scss";

const MODAL_CLOSE_BUTTON_SELECTOR = ".js-close-continue-shopping-modal";

const getModalCloseButton$ = () => document.querySelector(MODAL_CLOSE_BUTTON_SELECTOR);

document.addEventListener("DOMContentLoaded", () => {
  getModalCloseButton$()?.addEventListener("click", event => {
    event.stopPropagation();
    postponeRendering(() => {
      $(".modal").modal("hide");
    });
  });
});
